import { getStatusConfig } from '@/features/_constants/admission-status'
import type { TUserType } from '@/features/_lib/auth-client.types'
import { queries } from '@/features/_lib/react-query'
import type {
  TApplicationStatus,
  TExposedApplicationAggregateDTO,
} from '@doutorsim/shared/applications'
import { useQuery } from '@tanstack/react-query'

import { EventStepItem } from './event-step-item'

interface EventStepsProps {
  application: TExposedApplicationAggregateDTO
  userType: TUserType
}

export const EventSteps = ({ application, userType }: EventStepsProps) => {
  const { data: eventSteps = [] } = useQuery({
    ...queries.applications.statusHistory(
      application.id,
      application.companyId,
      application.facilityId,
    ),
    enabled: !!application.companyId && !!application.facilityId,
  })

  return eventSteps.map((event: any, index: number) => {
    const label = getStatusConfig(event.newStatus as TApplicationStatus, userType)?.label

    return (
      <EventStepItem
        key={event.id}
        eventStep={event}
        order={eventSteps.length - index}
        personId={application?.personId}
        eventLabel={label}
      />
    )
  })
}
